export enum LocalStorageKeys {
    VoiceAIInsightsFilter = "VoiceAIInsightsFilter",
  }
  